import {Component, Input, OnInit} from '@angular/core';
import {DecodedDosOrderDataInterface, DosOrderInterface} from '../../../../models/sharedinterface';
import {I18nService} from '../../../../shared/services/i18n.service';
import * as moment from 'moment';

@Component({
  selector: 'app-dos-order-details',
  templateUrl: './dos-order-details.component.html',
  styleUrls: ['./dos-order-details.component.scss']
})
export class DosOrderDetailsComponent implements OnInit {

  @Input() order: DosOrderInterface;

  public decodedOrderData: DecodedDosOrderDataInterface;

  constructor(public i18n: I18nService) {
  }

  ngOnInit(): void {
    this.decodedOrderData = JSON.parse(this.order.jsondata);

    console.log(this.decodedOrderData.orderdata);
  }

  getCreatedDate(): string {
    return moment(new Date(this.order.created.date)).format('DD/MM/YYYY HH:mm');
  }

  getDeliveryDate(): string {
    return moment(new Date(this.order.delivery.date)).format('DD/MM/YYYY HH:mm');
  }

  getAllLanguages(): string {
    const languages: string[] = [];
    for (const orderKey in this.decodedOrderData.orderdata) {
      if (this.decodedOrderData.orderdata.hasOwnProperty(orderKey)) {
        const order = this.decodedOrderData.orderdata[orderKey];
        for (const machineLanguage of order._machinelanguages) {
          if (machineLanguage._quantity > 0 && languages.indexOf(machineLanguage._languageiso2) === -1) {
            languages.push(machineLanguage._languageiso2);
          }
        }
      }
    }
    return languages.join(', ');
  }

  getAccountableOrders() {
    return [];
  }
}
